export default __webpack_public_path__ + "static/media/broccoli.0c36fc21.png";